import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: "Shield",
      title: "Bank-Level Security",
      description: "Your assets are protected with institutional-grade encryption, multi-factor authentication, and cold storage solutions. FDIC insured USD deposits up to $250,000.",
      color: "var(--color-primary)"
    },
    {
      icon: "GraduationCap",
      title: "Education-First Approach",
      description: "Access comprehensive learning resources, market analysis, and investment strategies designed for both beginners and experienced traders.",
      color: "var(--color-secondary)"
    },
    {
      icon: "Zap",
      title: "Lightning-Fast Trading",
      description: "Execute trades instantly with our optimized platform. Real-time market data, advanced charting tools, and seamless order execution.",
      color: "var(--color-accent)"
    },
    {
      icon: "Users",
      title: "24/7 Expert Support",
      description: "Our dedicated support team is available around the clock to assist you with any questions or concerns about your account or trading.",
      color: "var(--color-brand-primary)"
    },
    {
      icon: "Wallet",
      title: "Easy Funding Options",
      description: "Seamless ACH integration, instant deposits, and multiple payment methods. Clear fee structures with no hidden charges.",
      color: "var(--color-brand-secondary)"
    },
    {
      icon: "FileCheck",
      title: "Regulatory Compliance",
      description: "Fully compliant with FinCEN and SEC guidelines. Transparent operations with regular third-party security audits and certifications.",
      color: "var(--color-brand-trust)"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-4">
            Why Choose Kryptostash?
          </h2>
          <p className="text-base md:text-lg text-[var(--color-muted-foreground)] max-w-3xl mx-auto">
            Experience the perfect blend of security, education, and innovation. We make cryptocurrency investing accessible, safe, and rewarding for everyone.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <div 
              key={index}
              className="bg-[var(--color-card)] rounded-xl p-6 md:p-8 border border-[var(--color-border)] hover:shadow-lg transition-shadow duration-300"
            >
              <div 
                className="w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center mb-4 md:mb-6"
                style={{ backgroundColor: `${feature?.color}15` }}
              >
                <Icon name={feature?.icon} size={24} color={feature?.color} />
              </div>
              
              <h3 className="text-lg md:text-xl font-semibold text-[var(--color-foreground)] mb-3">
                {feature?.title}
              </h3>
              
              <p className="text-sm md:text-base text-[var(--color-muted-foreground)] leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;